<template>
  <div class="overview-inbox ov-card">
    <div class="ov-block-title">
      <i class="material-icons ov-title-icon">question_answer</i>
      <h2>{{ $t('dash.overview.widgets.inbox.title') }}</h2>
      <span v-if="count" class="ov-chip-muted">{{ count > 999 ? '999+' : count }}</span>
      <button class="ov-arrow-link ov-block-link" @click="$emit('go', { name: 'moderation' })">{{ $t('dash.overview.alerts.open_inbox') }}<i class="material-icons">arrow_forward</i></button>
    </div>
    <div class="overview-inbox-list">
      <InboxWidget :events="events" :loading="loading" @load-inbox="$emit('load-inbox')" @open-inbox-event="ev => $emit('open-inbox-event', ev)" />
    </div>
  </div>
</template>

<script>
import InboxWidget from './modules/widgets/InboxWidget.vue'

/**
 * Derniers événements reçus dans l'Inbox (en attente), sous « À venir » dans l'overview général
 */
export default {
  name: 'OverviewInbox',

  components: { InboxWidget },

  props: {
    events: { type: Array, default: null },
    count: { type: Number, default: 0 },
    loading: { type: Boolean, default: false }
  }
}
</script>

<style scoped>
.overview-inbox {
  display: flex;
  flex-direction: column;
  min-height: 0;
}
.overview-inbox-list >>> .iw-skeleton {
  height: 160px;
}
.overview-inbox-list {
  flex: 1;
  min-height: 0;
  max-height: 320px;
  overflow-y: auto;
  padding-right: 4px;
}
</style>
